(function() {
  var CropYear,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  CropYear = App.loadClass("core::CropYear");

  exports.ChangesToSave = (function() {
    function ChangesToSave() {
      this.clear = bind(this.clear, this);
      this.update = bind(this.update, this);
      this.reset = bind(this.reset, this);
      this.changesMade = bind(this.changesMade, this);
      this.toDelete = bind(this.toDelete, this);
      this.toAdd = bind(this.toAdd, this);
      this.clear();
    }

    ChangesToSave.prototype.toAdd = function() {
      return _.difference(this.keyFields, this.originalKeyFields);
    };

    ChangesToSave.prototype.toDelete = function() {
      return _.difference(this.originalKeyFields, this.keyFields);
    };

    ChangesToSave.prototype.changesMade = function() {
      var to_add, to_delete;
      if (this.keyFields.length === 0 && this.originalKeyFields.length === 0) {
        return false;
      }
      to_add = this.toAdd();
      to_delete = this.toDelete();
      return to_add.length > 0 || to_delete.length > 0;
    };

    ChangesToSave.prototype.reset = function() {
      return this.keyFields = _.clone(this.originalKeyFields);
    };

    ChangesToSave.prototype.update = function() {
      return this.originalKeyFields = _.clone(this.keyFields);
    };

    ChangesToSave.prototype.clear = function() {
      this.keyFields = [];
      return this.originalKeyFields = [];
    };

    return ChangesToSave;

  })();

}).call(this);
